import type { RealtimeHandler } from "@/shared/realtime";

import { MATCH_LIST_QUERY_KEY } from "../api/MATCH_LIST_QUERY_KEY";
import { STATS_SUMMARY_QUERY_KEY } from "../api/STATS_SUMMARY_QUERY_KEY";

// `stats.updated` → быстрый разбор пересчитан: сводка и оценки в списке матчей перечитываются
// через REST. Повтор события — ещё одна инвалидация, данные те же.
export const handleStatsUpdated: RealtimeHandler<"stats.updated"> = (_event, { queryClient }) => {
  void queryClient.invalidateQueries({ queryKey: STATS_SUMMARY_QUERY_KEY });
  void queryClient.invalidateQueries({ queryKey: MATCH_LIST_QUERY_KEY });
};
